import { css } from 'emotion';

const divider = css`
  margin-bottom: 19px !important;
`;

const buttonsRow = css`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const spacer = css`
  flex: 1 1 auto;
`;

const backButton = css`
  margin-left: 10px;
`;

const containerLoading = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20vh;
`;

export default {
  spacer,
  divider,
  backButton,
  buttonsRow,
  containerLoading,
};
